import PropTypes from "prop-types";
import React, { Component } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { connect } from "react-redux";
import { addFieldData, setItemBreadcrumbs, setReturnedValue } from "../actions";
import { fetcher } from "../utils/fetcher";
import { translator } from "../utils/i18n";

class ChooserTypeConsultation extends Component {
  state = {
    value: "",
    dataValue: ""
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
  }

  handleChange = event => {
    const returnedKey = this.props.step.returned.key;
    const value = event.target.value;
    if (returnedKey && value !== "") {
      this.props.isValid(true);
      this.props.setReturnedValue({
        [returnedKey]: value
      });
    } else {
      this.props.isValid(false);
    }
    if (value === "teleconsult") {
      fetcher(true, { telconsul: "ok" });
    }
  };

  render() {
    const { step } = this.props;
    return (
      <div className="wrap-chooser text-grey">
        <label>{step.label}</label>
        <div className="content-chooser">
          <RadioGroup
            aria-label={step.label}
            name={"chooser"}
            onChange={this.handleChange}
          >
            <FormControlLabel
              labelPlacement="end"
              value="teleconsult"
              control={<Radio color="primary" />}
              label={translator()._("W_TELECONSULTATION")}
            />
            <FormControlLabel
              labelPlacement="end"
              value="normal"
              control={<Radio color="primary" />}
              label={translator()._("W_SUR_SITE")}
            />
          </RadioGroup>
        </div>
      </div>
    );
  }
}

ChooserTypeConsultation.propTypes = {
  fetchData: PropTypes.func,
  isValid: PropTypes.func,
  resetData: PropTypes.func,
  setReturnedValue: PropTypes.func,
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    label: PropTypes.any,
    returned: PropTypes.shape({
      key: PropTypes.any
    })
  })
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChooserTypeConsultation);
